module.exports = __webpack_public_path__ + "img/card-linear.807febc2.svg";